import "bootstrap/dist/css/bootstrap.min.css"
import { SnackbarProvider } from "notistack"
import { useEffect, useState } from "react"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { ErrorBoundary } from "react-error-boundary"
import { BrowserRouter } from "react-router-dom"

import { Button } from "@material-ui/core"

import Permissoes from "./permissoes"

import flatErro from "./assets/fail-flat.svg"
import { RegistrarLogErro } from "./services/clientefiel"

import TagManager from "react-gtm-module"
import { ParametrosContextProvider } from "./contexts/ParametrosContext"
import GoogleMapsProvider from "./pages/GoogleMaps/GoogleMapsProvider"
import useAppStore from "./stores/AppStore"

const tagManagerArgs = { gtmId: "GTM-P7ZLCTD" }

function ErrorHandler({ error }) {
    useEffect(() => {
        RegistrarLogErro(error, "Render - Recebedor de Pedidos")
    }, [])

    const [today] = useState(new Date())
    const [date] = useState(
        today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
    )
    const [time] = useState(today.getHours() + ":" + today.getMinutes())

    function handleClick() {
        localStorage.clear()
        window.location.href = window.location.href
    }

    return (
        <div
            style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                padding: "2em",
                position: "absolute",
            }}
        >
            <img
                src={flatErro}
                alt={"loading erro"}
                className="pretoEBranco"
                style={{ width: "350px", marginBottom: "1em" }}
            />
            <h6>Houve um erro no aplicativo!</h6>
            <p>
                Tire um print dessa tela e envie para os desenvolvedores, após isso resete o app
                clicando no botão "RESETAR" para voltar ao normal.
            </p>
            <p>Erro: {error.message}</p>
            <span style={{ marginBottom: "24px" }}>
                {date} - {time}
            </span>
            <div style={{ display: "flex", gap: "1em" }}>
                <Button
                    variant="outlined"
                    color="default"
                    onClick={() => {
                        window.location.href = "/"
                    }}
                >
                    VOLTAR
                </Button>
                <Button variant="outlined" color="default" onClick={handleClick}>
                    RESETAR
                </Button>
            </div>
            <span style={{ marginTop: "1em", color: "rgba(0,0,0,0.6)" }}>
                Ao clicar em <span style={{ color: "red" }}>'Resetar'</span>, todas as configurações
                da impressora serão perdidas e deverão ser configuradas novamente.
            </span>
        </div>
    )
}

function App() {
    const configuracoes = useAppStore(s => s.configuracoes)
    const apiKey = configuracoes?.user?.parametros?.tokenGoogleMaps

    useEffect(() => {
        TagManager.initialize(tagManagerArgs)
    }, [])

    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>
            <ParametrosContextProvider>
                <SnackbarProvider maxSnack={3}>
                    <DndProvider backend={HTML5Backend}>
                        {apiKey ? (
                            <GoogleMapsProvider apiKey={apiKey}>
                                <BrowserRouter>
                                    <Permissoes />
                                </BrowserRouter>
                            </GoogleMapsProvider>
                        ) : (
                            <BrowserRouter>
                                <Permissoes />
                            </BrowserRouter>
                        )}
                    </DndProvider>
                </SnackbarProvider>
            </ParametrosContextProvider>
        </ErrorBoundary>
    )
}

export default App
